<template style="display: inline-block">
    <span v-if="typeof data === 'string'">
        <simple-code :data="data"></simple-code>
    </span>
    <span v-else-if="typeof data === 'object' && data !== null">
        <span v-for="(key, index) in Object.keys(data)" :key="index">
            <simple-code :data="data[key]"></simple-code>
        </span>
    </span>
    <span v-else-if="Array.isArray(data)">
        <span v-for="(item, index) in data" :key="index">
            <simple-code :data="item" v-if="typeof data==='string'"></simple-code>
            <span v-else-if="typeof item === 'object' && item !== null">
                <span v-for="(key, index) in Object.keys(item)" :key="index">
                    <simple-code :data="item[key]"></simple-code>
                </span>
            </span>
            <span v-else>
                {{item}}
            </span>
        </span>
    </span>
    <span v-else>
        {{data}}
    </span>
</template>

<script>
    import SimpleCode from './SimpleCode';
    export default {
        name: "CodeData",
        props: ['data'],
        components: {
            'simple-code': SimpleCode,
        },
    }
</script>

<style scoped>

</style>